/* Localize observed app labels; preserve fields, targeting and submission handlers. */
(() => {
  'use strict';
  const selector = ['WuZLHv', 'Tvx3Zu', 'Tzxe3N']
    .map(id => `form[data-testid="klaviyo-form-${id}"]`).join(',');
  const text = new Map([
    ['Email', 'Netfang'],
    ['This field is required', 'Þennan reit þarf að fylla út.'],
  ]);
  let queued = false;
  function localize() {
    queued = false;
    if (location.pathname === '/products/gjafabref-hja-dyravinum') {
      document.querySelectorAll('variant-selects legend').forEach(legend => {
        if (legend.textContent.trim() === 'Denominations') legend.textContent = 'Upphæð';
      });
    }
    document.querySelectorAll(selector).forEach(form => {
      form.querySelectorAll('input').forEach(input => {
        for (const attribute of ['placeholder', 'aria-label']) {
          if (input.getAttribute(attribute) === 'Email') input.setAttribute(attribute, 'Netfang');
        }
      });
      const walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const replacement = text.get(node.textContent.trim());
        if (replacement) node.textContent = replacement;
      }
      const close = form.parentElement?.querySelector('.klaviyo-close-form');
      if (close?.getAttribute('aria-label') === 'Close dialog') close.setAttribute('aria-label', 'Loka glugga');
    });
  }
  new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(localize);
    }
  }).observe(document.body, { childList: true, subtree: true });
  localize();
})();
